import { Link, useNavigate, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import styles from "./Header.module.css";
import logo from "./logo.png";
import { RxCross1, RxHamburgerMenu } from "react-icons/rx";
import { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "My Dive", to: "/my-dive" },
  { label: "Contact", to: "/#contact", hash: true },
];

export const Header = ({ transparent = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [drawerOpen]);

  const isLight = transparent && !scrolled;
  const headerClass = [
    styles.header,
    isLight ? styles.headerLight : styles.headerSolid,
    transparent ? styles.headerOverlay : "",
  ].join(" ");

  const renderLink = (link, className) =>
    link.hash ? (
      <HashLink key={link.label} smooth to={link.to} className={className}>
        {link.label}
      </HashLink>
    ) : (
      <Link key={link.label} to={link.to} className={className}>
        {link.label}
      </Link>
    );

  return (
    <>
      <header className={headerClass}>
        <div className={styles.inner}>
          <button
            type="button"
            className={styles.brand}
            onClick={() => navigate("/")}
            aria-label="MY Adventures — home"
          >
            <img src={logo} className={styles.logo} alt="" />
            <span className={styles.brandText}>
              <span className={styles.brandTitle}>MY Adventures</span>
              <span className={styles.brandTagline}>Maldives Dive Centre</span>
            </span>
          </button>

          <nav className={styles.nav} aria-label="Primary">
            {NAV_LINKS.map((link) => renderLink(link, styles.navLink))}
          </nav>

          <button
            type="button"
            className={styles.menuButton}
            onClick={() => setDrawerOpen(true)}
            aria-label="Open menu"
          >
            <RxHamburgerMenu />
          </button>
        </div>
      </header>

      <div
        className={`${styles.drawerScrim} ${drawerOpen ? styles.drawerScrimOpen : ""}`}
        onClick={() => setDrawerOpen(false)}
        aria-hidden="true"
      />
      <aside
        className={`${styles.drawer} ${drawerOpen ? styles.drawerOpen : ""}`}
        aria-hidden={!drawerOpen}
      >
        <div className={styles.drawerHead}>
          <span className={styles.drawerEyebrow}>Menu</span>
          <button
            type="button"
            className={styles.drawerClose}
            onClick={() => setDrawerOpen(false)}
            aria-label="Close menu"
          >
            <RxCross1 />
          </button>
        </div>
        <nav className={styles.drawerNav}>
          {NAV_LINKS.map((link) => renderLink(link, styles.drawerLink))}
        </nav>
        <div className={styles.drawerFoot}>
          <span className={styles.drawerEyebrow}>Maldives</span>
        </div>
      </aside>
    </>
  );
};
